import { useMemo } from 'react';

import { cn, ConditionalRender, Skeleton, Stack } from '@crossnokaye/ux-common';

import { IconConfig, IconConfigVariant } from '@repo/sdk/models/components';

import { AnimaticIcon } from '@/features/equipment-browser/animatics/animatic-icon';

import { AnimaticShelfCarousel } from './animatic-shelf-carousel';

type ShelfIconSectionProps = {
  icon: IconConfig;
  isMobile: boolean;
};

const ShelfIconSection = ({ icon, isMobile }: ShelfIconSectionProps) => {
  const iconVariant = icon.variant ?? IconConfigVariant.Default;
  const label = icon.label;
  return (
    <Stack className="w-full items-center p-2 @2xl:p-1" gap="thin">
      <AnimaticIcon icon={icon.icon} variant={iconVariant} size={isMobile ? 'sm' : 'md'} />
      <ConditionalRender condition={!!label}>
        <span className={cn('text-base font-bold leading-5 @2xl:text-sm')}>{label}</span>
      </ConditionalRender>
    </Stack>
  );
};

type AnimaticShelfIconsProps = {
  icons: IconConfig[];
  isMobile: boolean;
};

export const AnimaticShelfIcons = ({
  icons,
  isMobile,
}: AnimaticShelfIconsProps): React.ReactNode => {
  const carouselItems = useMemo(
    () =>
      icons.map((icon, index) => ({
        key: `${icon.icon}-${index}`,
        content: <ShelfIconSection icon={icon} isMobile={isMobile} />,
      })),
    [icons, isMobile]
  );

  return (
    <AnimaticShelfCarousel items={carouselItems} itemLayout="equalThirds" className="text-white" />
  );
};

export const IconShelfSkeletons = () => {
  return (
    <Stack className="w-full" gap="sm">
      <Skeleton className="w-40 h-4" />
      <Skeleton className="w-full h-10" />
    </Stack>
  );
};
